/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Box, Button, Typography } from "@mui/material";

import { useStyles } from "./styles";
import { MESSAGES, TITLES } from "./constants";
import Loader from "../../shared/loader/Loader";
import FormDialog from "../../shared/dialog/FormDialog";
import { selectLoader } from "../../store/loader/loaderSelector";

interface IDeleteRealmDialogProps {
  openModal: boolean;
  realmData?: IRealmData;
  onClose: Function;
  deleteRealm: Function;
};

interface IRealmData {
  id: string;
  realmName?: string;
  name?: string;
};

export interface IErrorObj {
  error?: boolean;
  errorHelperText?: string;
};

const DeleteRealmDialog = (props: IDeleteRealmDialogProps) => {
  const classes = useStyles();
  const loading = useSelector(selectLoader);

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = async () => {
    props.deleteRealm();
  };

  return (
    <Fragment>
      <FormDialog
        dialogAction1={
          <Button
            color="primary"
            disableElevation
            name="cancelBtn"
            onClick={handleClose}
            variant="outlined"
          >
            {TITLES.CANCEL}
          </Button>
        }
        dialogAction2={
          <Button
            color="error"
            disableElevation
            variant="contained"
            onClick={handleSubmit}
            name="createCustomerBtn"
          >
            {TITLES.DELETE}
          </Button>
        }
        handleClose={handleClose}
        openModal={props.openModal}
        dialogTitle={TITLES.DELETE_REALM}
      >
        <Box className={classes.modalFormContent}>
          <Box>
            {MESSAGES.DELETE_REALM_MESSAGE}
            <Typography
              component="span"
              variant="body1"
              style={{ fontWeight: "bold" }}
            >
              {props.realmData?.realmName}
            </Typography>
            {MESSAGES.THIS_ACTION_CANNOT_BE_UNDONE}
          </Box>
        </Box>
        <Loader showLoader={loading} isCenter />
      </FormDialog>
    </Fragment>
  );
};

export default DeleteRealmDialog;
